<template>
  <div class="wt2-text-field">
    <span v-if="icon" :class="['wticon', icon]" />
    <input
      v-model="inputValue"
      :disabled="disabled"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :class="{ '-mandatoryError': mandatoryError }"
      ref="input"
    />
    <div class="-error-message wt2-text-s" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // define a default value
    value: {
      type: String,
      required: false,
    },
    // placeholder text
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      required: false,
      default: false,
    },
    mandatory: {
      required: false,
      default: false,
    },
    maxlength: {
      required: false,
    },
    icon: {
      type: [String],
      required: false,
      default: '',
    },
  },

  data() {
    return {
      inputValue: this.value,
      mandatoryError: this.mandatory && this.value.trim() === '',
    };
  },

  watch: {
    inputValue(value) {
      this.$emit('input', value);
      this.mandatoryError = this.mandatory && value === '';
    },
  },

  methods: {
    focus() {
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      });
    },
  },
};
</script>
